import { accept, reject } from "../reducer/reject.js";
import type { GameState, RunState } from "../types/index.js";
import { continuePendingRepeat } from "./completion.js";

type QualityChoice = Extract<NonNullable<RunState["pendingChoice"]>, { kind: "quality" }>;

export function toggleQualityChoice(
  state: GameState,
  pending: QualityChoice,
  value: "destroy" | "discard" | "return",
): GameState {
  if (pending.step >= pending.revealed.length) return reject(state, "すべて選択済みです");
  return accept({
    ...state,
    run: {
      ...state.run!,
      pendingChoice: { ...pending, step: pending.step + 1, decisions: [...pending.decisions, value] },
    },
  });
}

export function submitQualityChoice(state: GameState, pending: QualityChoice): GameState {
  if (pending.decisions.length !== pending.revealed.length) return reject(state, "すべてのカードを処理してください");
  const run = state.run!;
  const discarded = pending.revealed.filter((_, index) => pending.decisions[index] === "discard");
  const returned = pending.revealed.filter((_, index) => pending.decisions[index] === "return").reverse();
  return accept({
    ...state,
    run: continuePendingRepeat({ ...run, discard: [...run.discard, ...discarded], deck: [...run.deck, ...returned], pendingChoice: null }),
  });
}
